import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./global.css";
import "./i18next";

ReactDOM.render(<App />, document.getElementById("root"));
